<template>
  <Container
    :enabled-keyword="true"
    :hint-keyword="'No acc / cust no / nama'"
    :keyword="filter"
    :action="_refetchData"
  >
    <div class="card p-3 px-4">
      <form @submit.prevent="_refetchData" v-if="!isHideFilter">
        <div class="row">
          <div class="col form-group">
            <label for="" class="form-label">Filter Perusahaan</label>
            <selectize
              v-model="filter.id_perusahaan"
              @input="_getDepo()"
              :settings="{ maxItems: 99, plugins: ['remove_button'] }"
              multiple
              data-placeholder="Pilih Perusahaan"
            >
              <option :value="d.id" v-for="(d, i) in perusahaan" :key="i">
                {{ d.nama_perusahaan }}
              </option>
            </selectize>
          </div>
          <div class="col form-group">
            <label for="" class="form-label">Filter Depo</label>
            <selectize
              v-model="filter.id_depo"
              :settings="{ maxItems: 99, plugins: ['remove_button'] }"
              multiple
              data-placeholder="Pilih Depo"
            >
              <option :value="d.id" v-for="(d, i) in depo" :key="i">
                {{ d.nama_depo }}
              </option>
            </selectize>
          </div>
          <div class="col form-group">
            <label for="" class="form-label">Filter Tim</label>
            <selectize
              v-model="filter.id_tim"
              :settings="{ maxItems: 99, plugins: ['remove_button'] }"
              multiple
              data-placeholder="Pilih Tim"
            >
              <option :value="d.id" v-for="(d, i) in tim" :key="i">
                {{ d.nama_tim }}
              </option>
            </selectize>
          </div>
          <div class="col-auto form-group">
            <label for="" class="form-label">&nbsp;</label>
            <button
              type="submit"
              :disabled="loading"
              class="btn btn-primary"
              v-html="ic('search') + ' Fetch Data'"
            />
          </div>
        </div>
      </form>
    </div>
    <div class="alert alert-info" v-if="!requested">
      <i class="fe fe-info mr-2"></i>
      Select a filter and click "Fetch Data" to load the data. The list will
      only show
      <b>unverified</b> or <b>rejected</b> rows.
    </div>
    <DataTable
      :skeleton="loading"
      :noData="!loading && report.data.length === 0 && requested"
      :show="!loading && report.data.length > 0"
      :filter="filter"
      :action="_fetchData"
      :pagination="requested"
      :meta="report.meta"
    >
      <thead>
        <tr>
          <th>ID</th>
          <th>No Acc</th>
          <th>Cust No</th>
          <th>Tim</th>
          <th>Nama Toko</th>
          <th>Alamat</th>
          <th>Telephone</th>
          <th>Status</th>
          <th>Description</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row, i) in report.data" :key="i">
          <td>{{ row.id }}</td>
          <td
            @click="_openModal(row)"
            class="text-primary text-decoration-underline cursor-pointer"
          >
            {{ row.no_acc }}
          </td>
          <td>{{ row.cust_no }}</td>
          <td>{{ row.nama_tim }}</td>
          <td>{{ row.nama_toko }}</td>
          <td>{{ row.alamat }}</td>
          <td>{{ row.telepon }}</td>
          <td>
            <div
              :class="
                'rounded-pill text-white text-center p-1 py-0 ' +
                (row.status_verifikasi === 'rejected'
                  ? 'bg-danger'
                  : row.status_verifikasi === 'verified'
                  ? 'bg-success'
                  : 'bg-warning')
              "
            >
              {{
                row.status_verifikasi === "verified" ||
                row.status_verifikasi === "rejected"
                  ? row.status_verifikasi
                  : "unverified"
              }}
            </div>
          </td>
          <td>{{ row.reject_reason }}</td>
          <td>
            <button
              class="btn btn-sm btn-ghost"
              @click="_openModal(row)"
              v-html="ic('eye')"
            />
          </td>
        </tr>
      </tbody>
    </DataTable>
    <Modal
      className="modal-xl"
      :action="_closeModal"
      :title="'Verification toko'"
      :modal="modalControl"
    >
      <div class="modal-body">
        <div class="row">
          <div class="col-sm-6">
            <div class="row">
              <div
                :class="{
                  'form-group': true,
                  'col-sm-6': openedRow.is_pkp,
                  'col-sm-12': !openedRow.is_pkp,
                }"
                @click="scrollLeft"
              >
                <label class="form-label">No KTP</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="openedRow.no_ktp"
                  :class="{ 'border-danger': !openedRow.no_ktp }"
                  placeholder="Masukkan nomor KTP"
                />
              </div>
              <div
                v-if="openedRow.is_pkp"
                class="col-sm-6 form-group"
                @click="scrollRight"
              >
                <label class="form-label">NPWP</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="openedRow.npwp"
                  :class="{ 'border-danger': !openedRow.npwp }"
                  placeholder="Masukkan nomor NPWP"
                />
              </div>
              <div
                :class="{
                  'form-group': true,
                  'col-sm-6': openedRow.is_pkp,
                  'col-sm-12': !openedRow.is_pkp,
                }"
                @click="scrollLeft"
              >
                <label class="form-label">Nama KTP</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="openedRow.nama_ktp"
                  :class="{ 'border-danger': !openedRow.nama_ktp }"
                  placeholder="Masukkan nama sesuai KTP"
                />
              </div>
              <div
                v-if="openedRow.is_pkp"
                class="col-sm-6 form-group"
                @click="scrollRight"
              >
                <label class="form-label">Nama PKP</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="openedRow.nama_pkp"
                  :class="{ 'border-danger': !openedRow.nama_pkp }"
                  placeholder="Masukkan nama PKP"
                />
              </div>
              <div
                :class="{
                  'form-group': true,
                  'col-sm-6': openedRow.is_pkp,
                  'col-sm-12': !openedRow.is_pkp,
                }"
                @click="scrollLeft"
              >
                <label class="form-label">Alamat KTP</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="openedRow.alamat_ktp"
                  :class="{ 'border-danger': !openedRow.alamat_ktp }"
                  placeholder="Masukkan alamat sesuai KTP"
                />
              </div>
              <div
                v-if="openedRow.is_pkp"
                class="col-sm-6 form-group"
                @click="scrollRight"
              >
                <label class="form-label">Alamat PKP</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="openedRow.alamat_pkp"
                  :class="{ 'border-danger': !openedRow.alamat_pkp }"
                  placeholder="Masukkan alamat PKP"
                />
              </div>
              <div class="col-sm-6 form-group">
                <label class="form-label">Status</label>
                <div
                  style="text-transform: uppercase"
                  :class="
                    'rounded-lg text-white text-center p-2 py-2 ' +
                    (openedRow.status_verifikasi === 'rejected'
                      ? 'bg-danger'
                      : openedRow.status_verifikasi === 'verified'
                      ? 'bg-success'
                      : 'bg-warning')
                  "
                >
                  {{
                    openedRow.status_verifikasi === "verified" ||
                    openedRow.status_verifikasi === "rejected"
                      ? openedRow.status_verifikasi
                      : "unverified"
                  }}
                </div>
              </div>
              <div class="col-sm-6 form-group">
                <label class="form-label">Reject Reason</label>
                <selectize
                  v-model="openedRow.reject_reason"
                  data-placeholder="Reject reason"
                >
                  <option
                    :value="d"
                    v-for="(d, i) in [
                      'Data tidak lengkap',
                      'Data dan foto KTP tidak sesuai',
                      'Foto buram',
                    ]"
                    :key="i"
                  >
                    {{ d }}
                  </option>
                </selectize>
              </div>
            </div>
          </div>
          <div
            class="col-sm-6 d-flex overflow-auto align-items-center"
            :style="{
              height: '330px',
              border:
                openedRow.foto_ktp === '' ||
                openedRow.foto_ktp === null ||
                openedRow.foto_ktp === false ||
                (openedRow.is_pkp
                  ? openedRow.foto_npwp === '' ||
                    openedRow.foto_npwp == null ||
                    openedRow.foto_npwp === false
                  : false)
                  ? '1px solid red'
                  : '',
            }"
            ref="scrollContainer"
          >
            <img
              @click="scrollRight"
              :src="
                openedRow.foto_ktp
                  ? openedRow.foto_ktp
                  : 'https://via.placeholder.com/900x550/cccccc/666666?text=not+found'
              "
              style=""
            />
            <img
              @click="scrollLeft"
              v-if="openedRow.is_pkp"
              :src="openedRow.foto_npwp"
              style=""
            />
          </div>
          <div class="col-sm-12">
            <div class="row">
              <div class="col-sm-6 form-group">
                <label class="form-label font-weight-bold">Identifier</label>
                <div class="border p-2 rounded bg-white">
                  {{ openedRow.id }} / {{ openedRow.no_acc }} /
                  {{ openedRow.cust_no }} / TIM :
                  <span class="font-weight-bold">{{ openedRow.nama_tim }}</span>
                </div>
              </div>
              <div class="col-sm-3 form-group">
                <label class="form-label">Nama Toko</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="openedRow.nama_toko"
                  :class="{ 'border-danger': !openedRow.nama_toko }"
                  placeholder="Masukkan nama toko"
                />
              </div>
              <div class="col-sm-3 form-group">
                <label class="form-label">Telepon</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="openedRow.telepon"
                  :class="{ 'border-danger': !openedRow.telepon }"
                  placeholder="Masukkan nomor telepon"
                />
              </div>
              <div class="col-sm-6 form-group">
                <label class="form-label">Alamat</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="openedRow.alamat"
                  :class="{ 'border-danger': !openedRow.alamat }"
                  placeholder="Masukkan alamat toko"
                />
              </div>
              <div class="col-sm-6 form-group">
                <label class="form-label">Pemilik</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="openedRow.pemilik"
                  :class="{ 'border-danger': !openedRow.pemilik }"
                  placeholder="Masukkan nama pemilik"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mx-4 mb-3 d-flex justify-content-end align-items-center">
        <div>
          <button @click="_contactSupervisor" class="btn btn-info mr-2">
            Contact Suppervisor
          </button>
          <button @click="_rejectItem" class="btn btn-danger mr-2">
            Reject
          </button>
          <button
            @click="_approveItem"
            :disabled="!allowToApprove"
            class="btn btn-primary"
          >
            {{ allowToUpdate ? "Update & " : "" }}
            Approve
          </button>
        </div>
      </div>
      <!--      {{ openedToko }}-->
    </Modal>
  </Container>
</template>
<script>
import helper from "@/assets/js/helper.js";
import { mapActions } from "vuex";
import $axios from "@/api";

export default {
  name: "TokoUnverified",
  components: {},
  mixins: [helper],
  data() {
    return {
      requested: false,
      contactNumber: {
        koordinator_phone: "",
        supervisor_phone: "",
      },
      openedRow: {
        id: "",
        no_acc: "",
        cust_no: "",
        nama_tim: "",
        nama_toko: "",
        alamat: "",
        pemilik: "",
        telepon: "",
        status_verifikasi: "unverified",
        reject_reason: "",
        no_ktp: "",
        nama_ktp: "",
        alamat_ktp: "",
        foto_ktp: null,
        is_pkp: true,
        foto_npwp: null,
        npwp: "",
        nama_pkp: "",
        alamat_pkp: "",
      },
      historyRow: {
        id: "",
        no_acc: "",
        cust_no: "",
        nama_tim: "",
        nama_toko: "",
        alamat: "",
        pemilik: "",
        telepon: "",
        status_verifikasi: "unverified",
        reject_reason: "",
        no_ktp: "",
        nama_ktp: "",
        alamat_ktp: "",
        foto_ktp: null,
        is_pkp: true,
        foto_npwp: null,
        npwp: "",
        nama_pkp: "",
        alamat_pkp: "",
      },
      modalControl: {
        backdrop: false,
        modal: true,
      },
      report: {
        data: [],
        meta: {},
      },
      isHideFilter: false,
      loading: false,
      perusahaan: [],
      depo: [],
      tim: [],
      filter: {
        page: 1,
        per_page: 10,
        keyword: "",
        id_perusahaan: [],
        id_depo: [],
        id_tim: [],
      },
    };
  },
  computed: {
    allowToApprove() {
      const baseValidation =
        this.openedRow.id !== "" &&
        // this.openedRow.no_acc !== "" &&
        // this.openedRow.cust_no !== "" &&
        this.openedRow.nama_tim !== "" &&
        this.openedRow.nama_toko !== "" &&
        this.openedRow.pemilik !== "" &&
        this.openedRow.alamat !== "" &&
        this.openedRow.telepon !== "" &&
        this.openedRow.no_ktp !== "" &&
        this.openedRow.nama_ktp !== "" &&
        this.openedRow.alamat_ktp !== "" &&
        this.openedRow.foto_ktp !== "" &&
        this.openedRow.foto_ktp !== null &&
        this.openedRow.foto_ktp !== false;
      const pkpValidation = this.openedRow.is_pkp
        ? this.openedRow.npwp !== "" &&
          this.openedRow.nama_pkp !== "" &&
          this.openedRow.alamat_pkp !== "" &&
          this.openedRow.foto_npwp !== "" &&
          this.openedRow.foto_npwp !== null &&
          this.openedRow.foto_npwp !== false
        : true;
      return baseValidation && pkpValidation;
    },
    allowToUpdate() {
      return (
        this.openedRow.nama_toko !== this.historyRow.nama_toko ||
        this.openedRow.alamat !== this.historyRow.alamat ||
        this.openedRow.pemilik !== this.historyRow.pemilik ||
        this.openedRow.telepon !== this.historyRow.telepon ||
        this.openedRow.no_ktp !== this.historyRow.no_ktp ||
        this.openedRow.nama_ktp !== this.historyRow.nama_ktp ||
        this.openedRow.alamat_ktp !== this.historyRow.alamat_ktp ||
        this.openedRow.npwp !== this.historyRow.npwp ||
        this.openedRow.nama_pkp !== this.historyRow.nama_pkp ||
        this.openedRow.alamat_pkp !== this.historyRow.alamat_pkp
      );
    },
  },
  methods: {
    ...mapActions("perusahaan", ["getListPerusahaanByAccess"]),
    ...mapActions("depo", ["getListDepo"]),
    ...mapActions("tim", ["getListTim"]),
    scrollLeft() {
      const container = this.$refs.scrollContainer;
      container.scrollLeft = 0;
    },
    scrollRight() {
      const container = this.$refs.scrollContainer;
      container.scrollLeft = container.scrollWidth; // Scroll to the farthest right
    },
    _closeModal() {
      this.modalControl.backdrop = false;
    },
    _openModal(row) {
      this.openedRow = {
        id: row.id,
        no_acc: row.no_acc,
        cust_no: row.cust_no,
        nama_tim: row.nama_tim,
        nama_toko: row.nama_toko,
        pemilik: row.pemilik,
        alamat: row.alamat,
        telepon: row.telepon,
        status_verifikasi: row.status_verifikasi,
        reject_reason: row.reject_reason,
        no_ktp: row.no_ktp,
        nama_ktp: row.nama_ktp,
        alamat_ktp: row.alamat_ktp,
        is_pkp: row.is_pkp,
        npwp: row.npwp,
        nama_pkp: row.nama_pkp,
        alamat_pkp: row.alamat_pkp,
        foto_ktp: row.foto_ktp,
        foto_npwp: row.foto_npwp,
      };
      this.historyRow = {
        id: row.id,
        no_acc: row.no_acc,
        cust_no: row.cust_no,
        nama_tim: row.nama_tim,
        nama_toko: row.nama_toko,
        pemilik: row.pemilik,
        alamat: row.alamat,
        telepon: row.telepon,
        status_verifikasi: row.status_verifikasi,
        reject_reason: row.reject_reason,
        no_ktp: row.no_ktp,
        nama_ktp: row.nama_ktp,
        alamat_ktp: row.alamat_ktp,
        is_pkp: row.is_pkp,
        npwp: row.npwp,
        nama_pkp: row.nama_pkp,
        alamat_pkp: row.alamat_pkp,
        foto_ktp: row.foto_ktp,
        foto_npwp: row.foto_npwp,
      };
      this.modalControl.backdrop = true;
      this._getContactNumber();
    },
    _getPerusahaan() {
      this.getListPerusahaanByAccess({}).then((res) => {
        this.perusahaan = res;
      });
    },
    _getDepo() {
      this.getListDepo({ id_perusahaan: this.filter.id_perusahaan }).then(
        (res) => {
          this.depo = res;
        }
      );
    },
    _getTim() {
      this.getListTim({}).then((res) => {
        this.tim = res;
      });
    },
    async _approveItem() {
      try {
        const response = await $axios.post(
          "toko/" + this.openedRow.id + "/verify",
          this.openedRow
        );
        this.toast(response.data.message);
        await this._fetchData();
        this.modalControl.backdrop = false;
      } catch (error) {
        this.onError(error);
      }
    },
    async _rejectItem() {
      try {
        const response = await $axios.post(
          "toko/" + this.openedRow.id + "/reject",
          {
            reject_reason: this.openedRow.reject_reason,
          }
        );
        this.toast(response.data.message);
        await this._fetchData();
        this.modalControl.backdrop = false;
      } catch (error) {
        this.onError(error);
      }
    },
    async _fetchData() {
      this.requested = true;
      this.loading = true;
      this.report = {};
      try {
        const response = await $axios.get("toko/list/unverified", {
          params: this.filter,
        });
        this.report.data = response.data.data;
        this.report.meta = response.data.meta;
      } catch (e) {
        helper.methods.toast(e);
      }
      this.loading = false;
    },
    async _refetchData() {
      this.filter.page = 1;
      await this._fetchData();
    },
    async _getContactNumber() {
      try {
        const response = await $axios.get(
          `toko/${this.openedRow.id}/contact-number`
        );
        this.contactNumber = response.data;
      } catch (e) {
        helper.methods.toast(e);
      }
    },
    async _contactSupervisor() {
      let num = this.contactNumber.supervisor_phone;
      if (!num) return;
      if (typeof num === "string" && num.startsWith("08")) {
        num = num.replace(/^0/, "62");
      }
      let msg = `Halo, Tim ${this.openedRow.nama_tim}, terkait toko ${this.openedRow.nama_toko} dengan nomor akun ${this.openedRow.no_acc} yang bertempat di ${this.openedRow.alamat}.`;
      if (!this.allowToApprove) {
        msg += ` Mohon bantuannya untuk melengkapi data yang masih kurang.`;
      } else [(msg += ` Akan saya varify`)];
      const win = window.open(
        `https://api.whatsapp.com/send?phone=${num}&text=${msg}`,
        "_blank"
      );
    },
  },
  mounted() {
    this._getPerusahaan();
    this._getTim();
    this._fetchData();
  },
  created() {},
};
</script>
